var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.706,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#ED6B4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.717 23.147a.75.75 0 1 0-.894 1.204l.894-1.204Zm5.323 5.82a.75.75 0 1 0 .895-1.203l-.895 1.204Zm-5.28-10.67a6.079 6.079 0 0 1-5.473 6.63l.143 1.493a7.579 7.579 0 0 0 6.823-8.267l-1.494.143Zm-5.473 6.63a6.079 6.079 0 0 1-6.63-5.472l-1.493.143a7.579 7.579 0 0 0 8.266 6.822l-.143-1.493Zm-6.63-5.472a6.079 6.079 0 0 1 5.472-6.63l-.143-1.494a7.579 7.579 0 0 0-6.822 8.267l1.493-.143Zm5.472-6.63a6.079 6.079 0 0 1 6.63 5.471l1.494-.143a7.579 7.579 0 0 0-8.267-6.822l.143 1.493Zm5.694 11.526 6.217 4.617.895-1.204-6.218-4.617-.894 1.204Z",
    fill: "#fff"
  })));
};
export default SvgSearchIcon;